"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ExtLogger_1 = __importDefault(require("../modules/ExtLogger"));
var ExtFrameMessage_1 = require("./ExtFrameMessage");
var log_1 = require("../util/log");
/**
 * 小程序frame
 */
var ExtFrame = /** @class */ (function () {
    function ExtFrame(extMain, extEndpoint, adapter) {
        var _a;
        /**
         * 小程序iframe是否已销毁
         */
        this.destroyed = false;
        /**
         * 小程序业务iframe是否加载完毕
         */
        this.busiFrameLoaded = false;
        /**
         * 小程序iframe是否加载完毕
         */
        this.loaded = false;
        this.extMain = extMain;
        this.extEndpoint = extEndpoint;
        this.logger = ExtLogger_1["default"].getExtSysLogger({
            extUuid: extMain.extUuid,
            extType: extEndpoint.extType,
            log: function (logContent) { return adapter.log(logContent); }
        });
        this.iframe = document.createElement('iframe');
        this.iframe.setAttribute('sandbox', "allow-scripts allow-same-origin" + (((_a = extMain.extAppCspPolicy) === null || _a === void 0 ? void 0 : _a.hostLevel) === 3
            ? ' allow-popups allow-popups-to-escape-sandbox'
            : ''));
        this.iframe.setAttribute('allow', 'autoplay');
        this.iframe.setAttribute('src', adapter.getSupUrl(extMain));
        adapter.registerGroup(extMain);
    }
    /**
     * postMessage到小程序中间层iframe
     * @param topic 消息topic
     * @param payload 消息内容
     * @param adapter 小程序适配器
     */
    ExtFrame.prototype.postMessage = function (topic, payload, adapter) {
        if (this.iframe && this.iframe.contentWindow && this.loaded) {
            this.iframe.contentWindow.postMessage({ topic: topic, message: payload }, this.getSupOrigin(adapter));
        }
    };
    /**
     * postMessage到小程序业务iframe
     * @param topic 消息topic
     * @param payload 消息内容
     * @param adapter 小程序适配器
     */
    ExtFrame.prototype.postMessageToBusiFrame = function (topic, payload, adapter) {
        if (this.busiFrameLoaded) {
            this.postMessage(topic, payload, adapter);
            log_1.debugLogWithExtUuid(this.extMain.extUuid, "\u53D1\u9001\u6D88\u606F\u3010" + topic + "\u3011\u5230\u4E1A\u52A1iframe\u6210\u529F");
        }
        else {
            log_1.debugLogWithExtUuid(this.extMain.extUuid, "\u53D1\u9001\u6D88\u606F\u3010" + topic + "\u3011\u4E1A\u52A1\u5931\u8D25\uFF0Ciframe\u6CA1\u521D\u59CB\u5316");
            this.logger.debug('业务iframe还没有加载，忽略message', { topic: topic, payload: payload });
        }
    };
    /**
     * 触发接口调用结果消息到小程序业务iframe
     * @param rspTopic 响应topic
     * @param reqId 请求id
     * @param rsp 响应内容
     * @param adapter 小程序适配器
     */
    ExtFrame.prototype.postRsp = function (rspTopic, reqId, rsp, adapter) {
        this.postMessageToBusiFrame(rspTopic, { reqId: reqId, rsp: rsp }, adapter);
    };
    /**
     * 触发接口调用错误消息到小程序业务iframe
     * @param errTopic 错误topic
     * @param reqId 请求id
     * @param message 错误信息
     * @param adapter 小程序适配器
     */
    ExtFrame.prototype.postErr = function (errTopic, reqId, message, adapter) {
        this.postMessageToBusiFrame(errTopic, { reqId: reqId, err: message }, adapter);
    };
    /**
     * 获取中间层iframe的域
     */
    ExtFrame.prototype.getSupOrigin = function (adapter) {
        return window.location.protocol + "//" + adapter.getSupHost(this.extMain);
    };
    /**
     * 加载小程序业务iframe
     * @param adapter 小程序适配器
     */
    ExtFrame.prototype.load = function (adapter) {
        // 先清掉上次unload的定时器
        clearTimeout(this.unloadTId);
        this.postMessage(ExtFrameMessage_1.Topic.SUP_LOAD, {
            hostOrigin: window.location.origin
        }, adapter);
    };
    /**
     * 卸载小程序业务iframe
     * @param adapter 小程序适配器
     */
    ExtFrame.prototype.unload = function (adapter) {
        var _this = this;
        this.postMessage(ExtFrameMessage_1.Topic.SUP_UNLOAD, {
            hostOrigin: window.location.origin
        }, adapter);
        // TODO 要等消息消化完
        this.unloadTId = setTimeout(function () {
            _this.busiFrameLoaded = false;
        }, 1000);
    };
    /**
     * 销毁小程序frame（中间层iframe）
     */
    ExtFrame.prototype.destroy = function () {
        if (this.destroyed)
            return;
        this.iframe.setAttribute('src', 'about:blank');
        try {
            this.iframe.parentElement.removeChild(this.iframe);
        }
        catch (err) {
            this.logger.warn('删除iframe失败', { err: err.message });
        }
        this.iframe = null;
        this.destroyed = true;
        this.logger.info('extFrame已经销毁');
    };
    /**
     * 小程序iframe加载完毕
     */
    ExtFrame.prototype.ready = function () {
        this.loaded = true;
    };
    /**
     * 小程序业务iframe加载完毕
     */
    ExtFrame.prototype.busiReady = function () {
        this.busiFrameLoaded = true;
    };
    return ExtFrame;
}());
exports["default"] = ExtFrame;
